// extracted by mini-css-extract-plugin
export default {"footer":"SearchPanelFooter-module__footer___5OYr","message":"SearchPanelFooter-module__message__UoMhQ","actions":"SearchPanelFooter-module__actions__m_Cq1"};